import { useState } from "react";
import { Drawer } from "@mui/material";
import { ClipboardList, Plus, X } from "lucide-react";
import { MyConsultationsTable } from "pages/patient/PatientConsultationsPage/components/ConsultationsTable/MyConsultationsTable";

import { AddTaskModal } from "components/AddTaskModal/AddTaskModal";
import { Button } from "components/ui/Button";
import { TabSwitcher } from "components/ui/TabSwitcher";

import { ClosedTaskTable } from "./components/ClosedTasksTable/ClosedTaskTable";
import { SentTaskTable } from "./components/SentTasksTable/SentTaskTable";
import { TaskTable } from "./components/TasksTable/TaskTable";
import styles from "./MyTasksModal.module.css";

const TABS = [
  { value: "tasks", label: "Tasks" },
  { value: "consultations", label: "Consultations" },
  { value: "sent-items", label: "Sent Items" },
  { value: "closed-tasks", label: "Closed Tasks" },
];

export const MyTasksModal = ({ goToPatientDetails, goToPatientConsult }) => {
  const [tab, setTab] = useState("tasks");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="textGray"
        size="small"
        onClick={() => setOpen(true)}
        className={styles.myTasksButton}
      >
        <ClipboardList size={20} strokeWidth={2} aria-hidden />
        My Tasks
      </Button>

      <Drawer open={open} onClose={() => setOpen(false)} anchor="right">
        <div className={styles.drawerContent}>
          <div className={styles.drawerHeader}>
            <h2>My Tasks</h2>
            <button
              onClick={() => setOpen(false)}
              className={styles.closeButton}
            >
              <X />
            </button>
          </div>

          <div className={styles.tabContent}>
            <TabSwitcher
              options={TABS}
              value={tab}
              onChange={setTab}
              fullWidth
            />

            {tab === "tasks" && (
              <div className={styles.tableSection}>
                <div className={styles.tableSectionHeader}>
                  <h3 className={styles.tableSectionTitle}>Tasks</h3>
                  <AddTaskModal buttonText="Add task" buttonEndIcon={Plus} />
                </div>
                <TaskTable goToPatientDetails={goToPatientDetails} />
              </div>
            )}
            {tab === "consultations" && (
              <div className={styles.tableSection}>
                <div className={styles.tableSectionHeader}>
                  <h3 className={styles.tableSectionTitle}>Consultations</h3>
                </div>
                <MyConsultationsTable goToPatientConsult={goToPatientConsult} />
              </div>
            )}
            {tab === "sent-items" && (
              <div className={styles.tableSection}>
                <div className={styles.tableSectionHeader}>
                  <h3 className={styles.tableSectionTitle}>Sent Items</h3>
                  <AddTaskModal buttonText="Add task" buttonEndIcon={Plus} />
                </div>
                <SentTaskTable goToPatientConsult={goToPatientConsult} />
              </div>
            )}
            {tab === "closed-tasks" && (
              <div className={styles.tableSection}>
                <div className={styles.tableSectionHeader}>
                  <h3 className={styles.tableSectionTitle}>Closed Tasks</h3>
                  <AddTaskModal buttonText="Add task" buttonEndIcon={Plus} />
                </div>
                <ClosedTaskTable goToPatientDetails={goToPatientDetails} />
              </div>
            )}
          </div>
        </div>
      </Drawer>
    </>
  );
};
